import NewsUpdates from './newsUpdates'

const newsUpdates = new NewsUpdates()

newsUpdates.init()
